import { render } from "./ChecklistModelItem.vue?vue&type=template&id=80272eec"
import script from "./ChecklistModelItem.vue?vue&type=script&lang=js"
export * from "./ChecklistModelItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__